import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6rem;
	max-width: 136rem;
	width: 100%;
	margin: 0 auto;
	padding-top: calc(${(props) => props.theme.heights.header} + 8rem);
	padding-bottom: 8rem;
	@media screen and (max-width: 1380px) {
		padding: calc(${(props) => props.theme.heights.headerMobile} + 8rem) 2rem 8rem 2rem;
	}
	@media screen and (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		padding-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
	}
	@media screen and (max-width: 900px) {
		gap: 4rem;
	}
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const MenuBoxList = styled.div`
	display: flex;
	width: 100%;
`;
export const MenuMobileBoxList = styled.div`
	display: flex;
	gap: 0.8rem;
`;
export const MenuMobileBox = styled.div`
	width: 4rem;
	height: 4rem;
	background-color: #f1f3f5;
	color: #adb5bd;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 120%;
	letter-spacing: -0.6px;
	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}
`;
export const MenuBox = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 0.8rem;
	padding: 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 120%;
	letter-spacing: -0.6px;
	color: #dee2e6;
	background-color: #f1f3f5;
	white-space: nowrap;
	cursor: pointer;
	.sub_title {
		color: #495057;
	}
	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		.sub_title {
			color: #fff;
		}
	}
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const FieldCheckBox = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	justify-content: flex-end;
`;
export const NextButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
`;
